import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header style={{
      background: '#fff',
      borderBottom: '2px solid #f0f0f0',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
    }}>
      <div className="container-fluid" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px' }}>

          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <svg width="44" height="30" viewBox="0 0 123 82">
              <rect x="0" y="0" width="123" height="27" fill="#ff9933"/>
              <rect x="0" y="27" width="123" height="28" fill="#ffffff"/>
              <rect x="0" y="55" width="123" height="27" fill="#138808"/>
              <circle cx="61.5" cy="41" r="11" fill="none" stroke="#000080" strokeWidth="1"/>
              <line x1="61.5" y1="30" x2="61.5" y2="52" stroke="#000080" strokeWidth="0.8"/>
              <line x1="50.5" y1="41" x2="72.5" y2="41" stroke="#000080" strokeWidth="0.8"/>
              <line x1="53.7" y1="33.2" x2="69.3" y2="48.8" stroke="#000080" strokeWidth="0.8"/>
              <line x1="69.3" y1="33.2" x2="53.7" y2="48.8" stroke="#000080" strokeWidth="0.8"/>
            </svg>
            <div>
              <div style={{ fontWeight: 800, fontSize: '18px', color: '#1a56db', lineHeight: 1.1 }}>SR Indian Flags</div>
              <div style={{ fontSize: '11px', color: '#888', lineHeight: 1 }}>Quality Flags for Every Occasion</div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} className="d-none d-md-flex">
            <Link
              to="/about"
              style={{
                padding: '8px 18px', borderRadius: '8px', fontWeight: 600, fontSize: '14px',
                textDecoration: 'none',
                color: location.pathname === '/about' ? '#ff6600' : '#444',
                background: location.pathname === '/about' ? '#fff5ee' : 'transparent'
              }}
            >
              About Us
            </Link>

            <a
              href="https://wa.me/919700388626"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', gap: '7px',
                padding: '9px 18px', borderRadius: '8px',
                background: '#25d366', color: '#fff',
                fontWeight: 700, fontSize: '14px', textDecoration: 'none'
              }}
            >
              <i className="bi bi-whatsapp" style={{ fontSize: '16px' }}></i>
              WhatsApp Us
            </a>

            <a
              href="https://wa.me/919700388626?text=Hi, I'd like to place an order for flags."
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', gap: '7px',
                padding: '9px 18px', borderRadius: '8px',
                background: '#ff6600', color: '#fff',
                fontWeight: 700, fontSize: '14px', textDecoration: 'none'
              }}
            >
              <i className="bi bi-headset" style={{ fontSize: '15px' }}></i>
              Contact Us
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="d-md-none"
            onClick={() => setIsMobileMenuOpen(o => !o)}
            style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#444' }}
          >
            <i className={`bi ${isMobileMenuOpen ? 'bi-x' : 'bi-list'}`}></i>
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="d-md-none" style={{
            borderTop: '1px solid #f0f0f0', padding: '12px 0 16px',
            display: 'flex', flexDirection: 'column', gap: '8px'
          }}>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              style={{
                padding: '10px 16px', borderRadius: '8px', fontWeight: 600, fontSize: '15px',
                textDecoration: 'none', color: '#444'
              }}
            >
              About Us
            </Link>
            <a
              href="https://wa.me/919700388626"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding: '10px 16px', borderRadius: '8px', fontWeight: 700, fontSize: '15px',
                textDecoration: 'none', color: '#25d366', display: 'flex', alignItems: 'center', gap: '8px'
              }}
            >
              <i className="bi bi-whatsapp"></i> WhatsApp Us
            </a>
            <a
              href="https://wa.me/919700388626?text=Hi, I'd like to place an order."
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding: '10px 16px', borderRadius: '8px', fontWeight: 700, fontSize: '15px',
                textDecoration: 'none', color: '#ff6600', display: 'flex', alignItems: 'center', gap: '8px'
              }}
            >
              <i className="bi bi-headset"></i> Contact Us
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
